var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#B8EBF5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#FAFAFA",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.608 45.288C28.8773 45.288 26.968 44.5627 25.88 43.112C24.792 41.6613 24.248 39.1227 24.248 35.496C24.248 31.6987 24.9733 28.936 26.424 27.208C27.8747 25.48 30.1893 24.616 33.368 24.616C33.9227 24.616 34.4987 24.648 35.096 24.712C35.6933 24.7547 36.1413 24.808 36.44 24.872V28.136C35.928 28.072 35.416 28.0293 34.904 28.008C34.392 27.9867 33.88 27.976 33.368 27.976C31.576 27.976 30.296 28.36 29.528 29.128C28.7813 29.8747 28.3227 31.2293 28.152 33.192C29.0053 32.7227 29.8267 32.392 30.616 32.2C31.4053 32.008 32.2587 31.912 33.176 31.912C34.9893 31.912 36.3333 32.4347 37.208 33.48C38.0827 34.504 38.52 36.0827 38.52 38.216C38.52 40.4347 37.912 42.1733 36.696 43.432C35.48 44.6693 33.784 45.288 31.608 45.288ZM34.808 38.376C34.808 37.16 34.584 36.3173 34.136 35.848C33.7093 35.3573 32.92 35.112 31.768 35.112C31.1707 35.112 30.5307 35.1973 29.848 35.368C29.1653 35.5387 28.568 35.7627 28.056 36.04C28.0773 38.3013 28.3227 39.8373 28.792 40.648C29.2613 41.4373 30.1573 41.832 31.48 41.832C32.5893 41.832 33.4213 41.544 33.976 40.968C34.5307 40.392 34.808 39.528 34.808 38.376Z",
    fill: "#0B4F5D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC6);
export default __webpack_public_path__ + "static/media/C6.4995628bd53c726a4571e1492dc75ab8.svg";
export { ForwardRef as ReactComponent };